import { render, staticRenderFns } from "./paymentCompany.vue?vue&type=template&id=73c08a10&scoped=true"
import script from "./paymentCompany.vue?vue&type=script&lang=js"
export * from "./paymentCompany.vue?vue&type=script&lang=js"
import style0 from "./paymentCompany.vue?vue&type=style&index=0&id=73c08a10&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c08a10",
  null
  
)

export default component.exports